import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Customers from "@/components/Customers";
import CustomerTestimonial from "@/components/CustomerTestimonial";
import OutsourcingSection from "@/components/OutsourcingSection";
import About from "@/components/About";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Services />
        <Customers />
        <CustomerTestimonial />
        <OutsourcingSection />
        <About />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
